import { render, staticRenderFns } from "./SelectEventType.vue?vue&type=template&id=1dc8ecdc&scoped=true&"
import script from "./SelectEventType.vue?vue&type=script&lang=js&"
export * from "./SelectEventType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc8ecdc",
  null
  
)

export default component.exports